require('../../modules/es7.array.includes');
module.exports = require('../../modules/_core').Array.includes;



//////////////////
// WEBPACK FOOTER
// ../~/core-js/library/fn/array/includes.js
// module id = 308
// module chunks = 1